import { trackCompletedOrder } from "@insite/client-framework/Common/Utilities/tracking";
import {
    addToChainAfter,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchCompletePlaceOrder,
    ExecuteOnSuccessCallback,
    SendTracking,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { dispatchCheckoutEvent, dispatchPurchaseEvent } from "@store/Framework/Services/AnalyticsService";
import cloneDeep from "lodash/cloneDeep";

replaceInChain(chain, SetCartStatus, props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    const notes = state.pages.checkoutShipping.editedCartNotes || ""; // Store Custom Code

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
          ? "PendingPaymentValidation"
          : "Submitted";

    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
        notes, // Store Custom Code
    };
});

replaceInChain(chain, ExecuteOnSuccessCallback, props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess && props.parameter.onSuccess(props.apiResult?.cart?.id); // Store Custom Code
    /* Store Custom Code - Start */
    dispatchCheckoutEvent(3, props.parameter.paymentMethod, props.cartToUpdate);
    /* Store Custom Code - End */
});

replaceInChain(chain, SendTracking, props => {
    const updatedCart = { ...props.cartToUpdate, orderNumber: props.apiResult.cart.orderNumber };
    const session = getSession(props.getState());
    trackCompletedOrder(updatedCart, props.apiResult.billTo, session);
    /* Store Custom Code - Start */
    dispatchPurchaseEvent(props.cartToUpdate, props.apiResult?.cart?.erpOrderNumber, props.apiResult?.billTo);
    /* Store Custom Code - End */
});

addToChainAfter(chain, DispatchCompletePlaceOrder, props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/SetNotes",
        notes: "",
    });
});
